const SHARED_TEMPLATE_URLS = {
  header: new URL("../templates/header.html", import.meta.url).toString(),
  library: new URL(
    "../templates/library-view.html",
    import.meta.url,
  ).toString(),
  transcript: new URL(
    "../templates/transcript-view.html",
    import.meta.url,
  ).toString(),
  vending: new URL(
    "../templates/vending-machine.html",
    import.meta.url,
  ).toString(),
};

async function fetchTemplate(url) {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`failed to load shared template: ${url}`);
  }
  return response.text();
}

export async function loadSharedTemplate(name) {
  const url = SHARED_TEMPLATE_URLS[name];
  if (!url) {
    throw new Error(`unknown shared template: ${name}`);
  }
  return fetchTemplate(url);
}

export async function loadSharedTemplates(names) {
  const targets = Array.isArray(names)
    ? names
    : Object.keys(SHARED_TEMPLATE_URLS);
  const entries = await Promise.all(
    targets.map(async (name) => [name, await loadSharedTemplate(name)]),
  );
  return Object.fromEntries(entries);
}

export const sharedTemplateUrls = { ...SHARED_TEMPLATE_URLS };
